
    import '/opt/buildhome/repo/packages/x/docs/playground/ultramodern.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-playground-ultramodern-demo-ultramodern"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/playground/ultramodern.zh-CN.md?type=demo')
};